import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';

export const findCompany = (userId) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/findUserCompany/${userId}`,
        method: 'GET',
    })
};
export const findUserId = () => {
    return request({
        url: `${baseUrl}/joins-basic/v1/user/token`,
        method: 'GET',
    })
};
export const userInfo = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/userInfo`,
        method: 'GET',
    })
};